import script from "./DataSectorsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./DataSectorsTable.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__